import { render, staticRenderFns } from "./MessagesTab.vue?vue&type=template&id=0ccad84c&scoped=true&"
import script from "./MessagesTab.vue?vue&type=script&lang=js&"
export * from "./MessagesTab.vue?vue&type=script&lang=js&"
import style0 from "./MessagesTab.vue?vue&type=style&index=0&id=0ccad84c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccad84c",
  null
  
)

export default component.exports